export const unlockPrePack = (prePack, unlockedPrePacksMap) => () => unlockedPrePacksMap.set(prePack.id, true);
//# sourceMappingURL=unlockPrePack.js.map